import React from 'react';
import { Link } from 'react-router-dom';
import isoSocLogo from '../assets/iso-soc-logo-1.svg';
import bgDesktop from '../assets/Banner-page-2-background.webp';
import bgMobile from '../assets/Banner-page-2-background-mobile.webp';
import heroScissors from '../assets/Hero-scissors.svg';

const cutYourCost = process.env.PUBLIC_URL + '/Banner-page-2-cut-your-cost-arrow.svg';

const Hero = () => {
    return (
        // Mobile: items-start + pt for navbar offset. Desktop: items-center
        <section className="relative w-full min-h-[70vh] md:min-h-screen flex items-start md:items-center bg-[#080D1A] overflow-hidden">
            {/* Backgrounds */}
            {/* Desktop Background */}
            <div className="absolute inset-0 hidden md:block z-0">
                <div className="absolute inset-0" style={{
                    background: `linear-gradient(90deg, #0B1221 0%, #1a2542 100%)`,
                    zIndex: -2
                }}></div>
                <div className="absolute inset-0" style={{
                    backgroundImage: `linear-gradient(to right, #0B1221  0%, #0B1221 40%, transparent 100%), url(${bgDesktop})`,
                    backgroundPosition: 'right center',
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'cover',
                    zIndex: -1
                }}></div>
            </div>

            {/* Mobile Background */}
            <div
                className="absolute inset-0 md:hidden z-0"
                style={{
                    backgroundImage: `linear-gradient(to right, #080D1A 0%, #080D1A 40%, transparent 100%), url(${bgMobile})`,
                    backgroundPosition: 'center, center bottom',
                    backgroundRepeat: 'no-repeat, no-repeat',
                    backgroundSize: 'cover, cover',
                    backgroundColor: '#080D1A'
                }}
            ></div>

            {/* Content Container */}
            {/* Mobile: pt-24 accounts for fixed navbar (h-20 = 80px + small gap). Desktop: different padding */}
            <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full pt-32 pb-6 md:pt-28 md:pb-20">
                <div className="flex flex-col md:flex-row items-start md:items-center">
                    {/* Content Column */}
                    <div className="w-full md:w-3/4 lg:w-2/3 text-left">

                        {/* Headline - Bigger on mobile */}
                        <h1 className="font-oswald text-white sm:text-[32px] text-4xl md:text-5xl leading-[1.35] md:!leading-[1.35] mb-16 md:mb-4 font-normal">
                            <strong className="font-bold">FGC TRADE<br />MANAGEMENT SYSTEM </strong>
                        </h1>

                        {/* Paragraph 1 with Scissors */}
                        <div className="relative">
                            {/* <p className="font-inter text-gray-200 text-[16px] sm:text-[16px] md:text-[22px] leading-relaxed mb-0 md:mb-24">
                                A Comprehensive Fixed Income Trading & Trade Management System -<br/> Cut Your System Costs by 50%+ with a cloud-native SaaS trusted by leading Broker-Dealers.
                            </p> */}

                            <ul className="font-inter text-gray-200 text-[16px] md:text-[16px] lg:text-[19px] xl:text-[22px] leading-relaxed mb-10 md:mb-24 list-disc pl-5 flex flex-col gap-2">
                                <li>
                                    A Comprehensive Fixed Income Trading and Management System
                                </li>
                                <li>
                                    Cut your System Costs by 50%+ with a cloud-native SaaS platform
                                </li>
                                <li>
                                    Trusted by leading Broker-Dealers.
                                </li>
                            </ul>

                            {/* Scissors with underline - responsive for mobile and desktop */}
                            <div className="absolute top-[85px] left-[25px] md:top-[60px] md:left-[22px] lg:top-[70px] lg:left-[24px] xl:top-[80px] xl:left-[25px]">
                                <img
                                    src={heroScissors}
                                    alt="Cut Your Costs"
                                    className="w-auto h-auto max-w-[250px] md:max-w-[400px]"
                                    fetchPriority="high"
                                />
                            </div>
                        </div>

                        {/* Button + Graphic Container */}
                        <div className="relative flex flex-row items-center gap-2 mt-0 md:mt-8">
                            {/* Bigger button on mobile */}
                            <Link
                                to="/schedule-demo"
                                className="bg-[#00C2FF] hover:scale-105 transition-transform duration-300 text-[#FFFFFF] text-[14px] sm:text-[16px] md:text-lg font-bold py-3.5 sm:py-3 md:py-4 px-7 sm:px-8 md:px-12 rounded-[16px] shadow-lg whitespace-nowrap md:-mt-12 inline-block text-center"
                            >
                                Request a Demo To See How!
                            </Link>
                        </div>

                        {/* Mobile ISO SOC - Left Aligned */}
                        <div className="mt-24 md:hidden flex justify-start">
                            <img src={isoSocLogo} alt="ISO Certified" className="h-18 sm:h-16 opacity-100" />
                        </div>

                        {/* Right Column (Desktop ISO) */}
                        <div className="mt-16 hidden md:block w-full md:w-1/4 lg:w-1/3 ">
                            <div className=" bottom-16 left-[10px]">
                                <img src={isoSocLogo} alt="ISO Certified" className="h-[60px]" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Hero;
